export default __webpack_public_path__ + "static/media/icon-shopping-bag.c8c26307.svg";